var colors = require("../colors/colors");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");

/**
 * @author Ed Pataky
 * @class HandleGridPopupInfo
 *
 * @description show width and height as popup metrics at position [data.pos().x, data.pos().y + data.height()/2]
 *
 * @param multipleSelectionFlag - 0=single object, 1=multiple objects
 * @param data - data model that has width() and height()
 * @param cameraModel -
 * @param gui -
 */
var HandleGridPopupInfo = function (multipleSelectionFlag, data, cameraModel, gui, svgGroup) {
    this.data = data;
    this.cameraModel = cameraModel;
    this.gui = gui;
    this.multipleSelectionFlag = multipleSelectionFlag;
    this.popupGroup = svgGroup;
};
module.exports = HandleGridPopupInfo;

HandleGridPopupInfo.prototype.emptySvgGroups = function() {
    if(this.svgPopup || this.svgPopupText) {
        $(this.svgPopup).remove();
        $(this.svgPopupText).remove();
        this.svgPopup = null;
        this.svgPopupText = null;
    }

    $(this.popupGroup).empty();
};

/**
 * Datamodel dependent label
 * @author E.Pataky
 * @function makeLabelString
 * @param data
 * @param idx - index of handle in case of multiple handle grids
 * @returns {string}
 */
HandleGridPopupInfo.prototype.makeLabelString = function (data, idx) {
    if(data instanceof cio_datamodel.LineData) {
        var p1 = new lib_geometry.Coord(data.x1(), data.y1());
        var p2 = new lib_geometry.Coord(data.x2(), data.y2());
        var angle = p2.sub(p1).angleDegrees();

        return parseInt(data.length() + (data.length() > 0 ? 0.5 : -0.5), 10) + " @ " +
            parseInt(angle + (angle > 0 ? 0.5 : -0.5), 10) + "°";
    } else {
        var pos = data.pos ? data.pos() : data.gPos(); // TODO: hack!
        var width = data.width ? data.width() : data.gWidth(); // TODO: hack!
        var height = data.height ? data.height() : data.gHeight(); // TODO: hack!
        if(idx == 5-1) {
            return parseInt(pos.getX() + (pos.getX() > 0 ? 0.5 : -0.5), 10) + ", " +
                parseInt(pos.getY() + (pos.getY() > 0 ? 0.5 : -0.5), 10);
        } else {
            return parseInt(width + (width > 0 ? 0.5 : -0.5), 10) + " x " +
                parseInt(height + (height > 0 ? 0.5 : -0.5), 10);
        }
    }
};

HandleGridPopupInfo.prototype.configPopInfo = function(enable, data, rotateInfo, idx) {
    if(this.svgPopup || this.svgPopupText) {
        $(this.svgPopup).remove();
        $(this.svgPopupText).remove();
        this.svgPopup = null;
        this.svgPopupText = null;
    }

    if(enable) {
        var popupBackgroundGroup = this.gui.svg.group(this.popupGroup);
        var popupTextGroup = this.gui.svg.group(this.popupGroup);

        var pos = data.pos ? data.pos() : data.gPos(); // TODO: hack!
        var width = data.width ? data.width() : data.gWidth(); // TODO: hack!
        var height = data.height ? data.height() : data.gHeight(); // TODO: hack!

        var coord = pos.add(
            new lib_geometry.Coord(
                0, - height/2
            )
        );

        var valStr = this.makeLabelString(data, idx);

        // create a rotated boundng box in case !rotateInfo and we want to put
        // the label under the (level) rotated BB
        var bb = new lib_geometry.BoundingBox(
            pos.getX(),
            pos.getY(),
            width, height);
        bb = bb.rotate((data.angle ? data.angle() : 0), pos);

        if(!rotateInfo) {
            coord = pos.add(
                new lib_geometry.Coord(
                    0, - bb.height/2
                )
            );
        }

        var angle = null;
        if(data.angle) {
            angle = data.angle();
            angle = (angle + 360) % 360; // use pos version of angle here
        }
        var textFlip = false;

        if(data instanceof cio_datamodel.LineData) {
            coord = pos;
            rotateInfo = true;
            var p1 = new lib_geometry.Coord(data.x1(), data.y1());
            var p2 = new lib_geometry.Coord(data.x2(), data.y2());
            angle = p2.sub(p1).angleDegrees();
            textFlip = (angle <= 90 && angle > 270 ? true : false);
            p1 = p2 = null; // cleanup
        } else if(!this.multipleSelectionFlag && angle != null) {
            textFlip = (angle <= 90 && angle > 270 ? true : false);
        }

        var vspacer = 15 / this.cameraModel.viewS();
        var hspacer = 20 / this.cameraModel.viewS();
        var fontSize = 11 / this.cameraModel.viewS();
        var textWidth = (valStr.length*(8 / this.cameraModel.viewS())); // estimate

        if(!(data instanceof cio_datamodel.LineData) && (idx == 5-1)) {
            coord = pos;
            rotateInfo = false;
        }

        // create text to get size
        var textX = coord.getX();
        var textY = -coord.getY() + fontSize + vspacer + (1 / this.cameraModel.viewS());

        this.svgPopupText = this.gui.svg.text(popupTextGroup,
            textX, textY,
            valStr,
            {
                'fill': '#FFFFFF',
                'fill-rule': "evenodd",
                'font-size': fontSize,
                'text-anchor': 'middle',
                // 'font-weight': 'bold', // extremely slow at startup :(
                'opacity': '1',
                'transform':
                    (rotateInfo && angle != null ?
                        (angle ? 'rotate(' + angle + ' ' + pos.x + ' ' + pos.y + ')'
                            : '')
                        : '') +  "scale( 1, -1) "  
            }
        );

        textWidth = this.svgPopupText.getBBox().width; // actual
        var realTextHeight = this.svgPopupText.getBBox().height;

        // draw background rect
        this.svgPopup = this.gui.svg.rect(popupBackgroundGroup,
            coord.getX() - (textWidth + hspacer)/2,
           - coord.getY() + vspacer,
            textWidth + hspacer, // w
            16 / this.cameraModel.viewS(), // h
            {
                'fill': colors.handleFillSelected,
                'stroke': 'none',
                'fill-rule': "evenodd",
                'opacity': '0.75',
                'rx': 8 / this.cameraModel.viewS(),
                'transform': (rotateInfo && angle != null ?
                    (angle ? 'rotate(' + angle + ' ' +
                    pos.x + ' ' + pos.y + ')' : '') : '')  +  "scale( 1, -1) "
            }
        );

        $(this.svgPopup).insertBefore(popupTextGroup);
    }
};
